import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import FastClick from 'fastclick';
import VueClipBoard from 'vue-clipboard2'
//import layer from 'vue2-layer-mobile';
import { Cascader } from 'vant';

FastClick.attach(document.body); // 解决移动端点击 300 毫秒延时问题
import '@/assets/css/reset.css';
import '@/assets/css/border.css';
import '@/assets/css/index.css';
import '@/assets/css/icon.styl';
// 执行移动端适配
require('./utils/adapter')(document, window);

//Vue.use(layer);
Vue.use(Lazyload);  
Vue.use(Vant);
//Vue.use(layer);
// 使用VueClipBoard插件，主要功能：类似于剪切板
Vue.use(VueClipBoard);
Vue.use(Cascader);

Vue.config.productionTip = false;
// 定义全局过滤器
Vue.filter('toFixed', function(value) {
  return Number(value).toFixed(2);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

//cors
var cors=require('cors');
app.use(cors({
    origin:['https://m.user.xpptp.com/'],  //指定接收的地址
    methods:['GET','POST'],  //指定接收的请求类型
    alloweHeaders:['Content-Type','Authorization']  //指定header
}))